import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchUnreadCount = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/staff-notifications/unread-count/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

const useGetNotificationUnreadCount = () => {
  return useQuery({
    queryKey: ["staff-notifications-unread-count"],
    queryFn: fetchUnreadCount,
    refetchInterval: 30000,
  });
};

export default useGetNotificationUnreadCount;
